export default `
§ uiKit.console.button: Копировать
§ uiKit.console.notification: Текст скопирован
§ uiKit.dataLoader.page: Страница
§ uiKit.dataLoader.size: Отображается по
§ uiKit.dataLoader.rows: строк.
§ uiKit.dataLoader.from: из
§ uiKit.dataLoader.all: Показать все
§ uiKit.hoursChart.work: стандартное рабочее время (будни, с 07:00 до 20:00)
§ uiKit.hoursChart.weekend: выходные дни или время до/после рабочего дня
§ uiKit.hoursChart.days: суммарное количество коммитов за все время в конкретный день и час
§ uiKit.page.remove: Удалить
§ uiKit.nothingFound.common.title: Нет или недостаточно данных для отображения
§ uiKit.nothingFound.common.description: Система обработает больше данных, если коммиты будут подписаны в формате [Git commit message convention|https://www.conventionalcommits.org/en/v1.0.0/]. Шаблон:
§ uiKit.nothingFound.common.console: Номер_задачи тип(фича): пояснение
§ uiKit.nothingFound.common.example: Например:
§ uiKit.nothingFound.staff.title: Нет данных для этого сотрудника
§ uiKit.nothingFound.staff.description1
Он вносил правки не каждый рабочий день и получил статус  «Помошник».
Работой сотрудников с таким статусом по данному проекту можно пренебречь, т.к. его влад на общем фоне незначителен.
§ uiKit.nothingFound.staff.description2
Поэтому система не рассчитывает для него ряд показателей.
Если это ошибка и данного сотрудника нужно рассчитать как обычного, перейдите в раздел «Настройки» и измените его тип.
§ common.title: Git статистика
§ common.filters: Фильтры
§ common.notifications.save: Изменения сохранены
§ common.notifications.setting: Настройки сохранены
§ common.fileLoader.notification: Ошибка загрузки файла $1
`;
